import { 
	GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURES, 
	GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURE,
	CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURE,
	UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURE,
	DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURE,
} from "./actions"

export function ProjectQaWeldingInspectionsWeldingProceduresReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURE}_FULFILLED`:
		case `${CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURE}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURE}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCEDURE}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaWeldingInspectionsWeldingProceduresReducer } from "modules/project/qa/welding_inspections/welding_procedures/reducer"

// project_qa_welding_inspections_welding_procedures:ProjectQaWeldingInspectionsWeldingProceduresReducer,
